var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8724 26.4728C13.1695 27.1757 12.0298 27.1757 11.3268 26.4728L4.12682 19.2728C3.42387 18.5698 3.42387 17.4302 4.12682 16.7272L11.3268 9.52721C12.0298 8.82426 13.1695 8.82426 13.8724 9.52721C14.5753 10.2302 14.5753 11.3698 13.8724 12.0728L9.7452 16.2L30.5996 16.2C31.5937 16.2 32.3996 17.0059 32.3996 18C32.3996 18.9941 31.5937 19.8 30.5996 19.8L9.7452 19.8L13.8724 23.9272C14.5753 24.6302 14.5753 25.7698 13.8724 26.4728Z",
    fill: "#310048"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowIcon);
export default __webpack_public_path__ + "static/media/black-arrow-icon.c1c9df2896eac7e4c28f610e0e9991ab.svg";
export { ForwardRef as ReactComponent };